import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[numeric]'
})

export class NumericDirective {

    @Input('decimals') decimals: number = 0;

    private specialKeys = [
      'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Control'
    ];

    private specialCharacters = [ 
        'a', //select all
        'c', //copy
        'v', //paste
        'x'  //cut
    ];

    constructor(private el: ElementRef) { }

    private check(value: string, decimals: number)
    {
      if (decimals <= 0) {
        return String(value).match(new RegExp(/^\d+$/));
      } else {
          var regExpString = "^\\s*((\\d+(\\.\\d{0," + decimals + "})?)|((\\d*(\\.\\d{1," + decimals + "}))))\\s*$"
          return String(value).match(new RegExp(regExpString));
      }
    }

    @HostListener('keydown', [ '$event' ])
    onKeyDown(event: KeyboardEvent) {

        if (this.specialKeys.includes(event.key) || //validate special Keys
            (event.ctrlKey === true || event.metaKey === true) && this.specialCharacters.includes(event.key)) //validate special characters only when Ctrl key (event.ctrlKey) is pressed. Note: event.metaKey is the Mac equivalent of ctrlKey.
        {
            return;  // do nothing, let it happen
        }

        let current: string = this.el.nativeElement.value;
        let next: string = current.concat(event.key);
        if ( next && !this.check(next, this.decimals) ) {
           event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const pastedInput: string = event.clipboardData
            .getData('text/plain')
            .replace(/\D/g, '');
        
        // get a digit-only string replacing the pasted content
        document.execCommand('insertText', false, pastedInput);
    }
}